<script lang="typescript">
    import { getString } from '@/utils'

    import { getContext, onDestroy, onMount } from 'svelte'

    const createComment: (comment) => void = getContext('createComment')

    let formVisible = false

    let commentInput = null
    let commentText = ''

    const modalId = getContext('modalId')

    $: commentInput ? commentInput.focus() : () => {}

    const showForm = () => {
        formVisible = true
        window.M.theme_soon.events.emit('MODAL_LOCK', { id: modalId, text: getString('confirm_unsaved_close', 'local_comments') })
    }

    const hideForm = () => {
        formVisible = false
        window.M.theme_soon.events.emit('MODAL_UNLOCK', { id: modalId })
    }

    function sendForm() {
        createComment({
            text: commentText
        })
        hideForm()
        commentText = ''
    }

</script>

{#if !formVisible}
    <p><a class="btn btn-primary" href="#new-comment" on:click|preventDefault={showForm}>
        Neuer Kommentar
    </a></p>
{:else}
    <div class="new-comment">
        <div class="form-group row">
            <textarea required class="form-control" name="new-comment" cols="30" rows="5" bind:value={commentText} bind:this={commentInput}></textarea>
        </div>
        <div class="form-group row justify-content-center">
            <input class="btn btn-primary" type="submit" value="Abschicken" on:click|preventDefault={sendForm}>
            <input class="btn btn-outline-primary" type="submit" value="Abbrechen" on:click={hideForm}>
        </div>
    </div>
{/if}
